import {VerifiedDomain} from "../_components/verified-domains/verified-domains.interface";

export const isDnsRecordVerified = (
  results: VerifiedDomain.VerificationResult[],
  type : VerifiedDomain.VerificationType
)=> {
  return results.find(
    ver => ver.record === type
  )?.verified;
}

export const getDnsRecords = (
  results: VerifiedDomain.VerificationResult[],
  type : VerifiedDomain.VerificationType
)=> {
  return results.find(
    ver => ver.record === type
  )?.records ?? [];
}
